module.exports = __webpack_public_path__ + "static/media/moto_1.9a09e3cb.png";